import React from 'react';

import NoFilteredResults from 'src/components/NoFilteredResults';
import type { PageDependedProps } from 'src/components/NoFilteredResults/NoFilteredResults';
import classnames from 'classnames';
import styles from './emptyHotels.module.css';
import type { IDeparture } from './DepartureList';
import { DepartureList } from './DepartureList';

interface Props extends PageDependedProps {
  linkedDepartures: IDeparture[] | null;
  isMobile?: boolean;
}

const EmptyHotels = ({
  linkedDepartures,
  isMobile = false,
  activeFilters,
  changeFilter,
  clearFilters,
  isMapExpanded,
}: Props) => (
  <div
    className={classnames(styles.container, {
      [styles.containerMobile]: isMobile,
    })}
  >
    <NoFilteredResults
      activeFilters={activeFilters}
      changeFilter={changeFilter}
      clearFilters={clearFilters}
      isMapExpanded={isMapExpanded}
    />
    {Array.isArray(linkedDepartures) && linkedDepartures.length ? (
      <LinkedDepartures
        linkedDepartures={linkedDepartures}
        isMobile={isMobile}
      />
    ) : null}
  </div>
);

interface LinkedDeparturesProps {
  linkedDepartures: IDeparture[];
  isMobile: boolean;
}

const LinkedDepartures = ({
  linkedDepartures,
  isMobile,
}: LinkedDeparturesProps) => {
  const { length } = linkedDepartures;

  // Делим на два столбца
  const halfLength = length % 2 === 0 ? length / 2 : length / 2 + 1;
  const deps1 = linkedDepartures?.slice(0, halfLength);
  const deps2 = linkedDepartures?.slice(halfLength, length);

  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.wrapperMobile]: isMobile,
        [styles.wrapperDesktop]: !isMobile,
      })}
    >
      <DepartureList departureList={deps1} />
      <DepartureList departureList={deps2} />
    </div>
  );
};

export default EmptyHotels;
